import "./App.css";
import { Switch, Redirect, Route, useLocation } from "react-router-dom";

import Signup from "./Components/Signup/Signup";
import Login from "./Components/Login/Login";
import Logout from "./Components/Logout/Logout";
import Main from "./Components/Main/Main";
import Search from "./Components/Main/Search";
import Prefer from "./Components/Signup/Prefer/Prefer";
import Verify from "./Components/Verify/Verify";
import Write from "./Components/Write/Write";
import { useEffect, useState } from "react";
import UserContext from "./context/UserContext";
import StoryDetails from "./Components/Story/StoryDetails";
import Stories from "./Components/Stories/Stories";
import ReaderView from "./Components/ReaderView/ReaderView";
import CriticMain from "./Components/CriticMain/CriticMain";
import Feedback from "./Components/Feedback/Feedback";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import PasswordReset from "./Components/PasswordReset/PasswordReset";
import Report from "./Components/Report/Report";
import CriticLayout from "./layouts/CriticLayout";
import WriterLayout from "./layouts/WriterLayout";
import AdminLayout from "./layouts/AdminLayout";
import ProducerLayout from "./layouts/ProducerLayout";
import AdminLogin from "./Components/AdminLogin/AdminLogin";
import ReactGA from "react-ga";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import config from "./config/apiConfig";
import AuthSSO from "./Components/AuthSSO/AuthSSO";

function usePageViews() {
    let location = useLocation();
    useEffect(() => {
        if (!window.GA_INITIALIZED) {
            ReactGA.initialize("UA-203686578-1");
            window.GA_INITIALIZED = true;
        }
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    }, [location]);
}

const theme = createMuiTheme({
    palette: {
        secondary: {
            main: config.primary_color
        }
    }
})

function App() {
    const [user, setUser] = useState({});

    usePageViews();

    return (
        <MuiThemeProvider theme={theme}>

        <UserContext.Provider value={[user, setUser]}>
            <div className="App">
                <Switch>
                    <Route path="/signup/verify/:verify_token">
                        <Verify />
                    </Route>
                    <Route path="/signup/preferences">
                        <Prefer />
                    </Route>
                    <Route path="/signup">
                        <Signup />
                    </Route>
                    <Route path="/admin-login">
                        <AdminLogin />
                    </Route>
                    <Route path="/login">
                        <Login />
                    </Route>
                    <Route path="/auth_sso">
                        <AuthSSO />
                    </Route>
                    <Route path="/logout">
                        <Logout />
                    </Route>
                    <Route path="/forgot_password">
                        <ForgotPassword />
                    </Route>
                    <Route path="/password/reset/:reset_token">
                        <PasswordReset />
                    </Route>

                    <Route path="/admin" component={AdminLayout} />
                    <Route path="/writer" component={WriterLayout} />
                    <Route path="/critic" component={CriticLayout} />
                    <Route path="/producer" component={ProducerLayout} />

                    <Route exact path="/">
                        <Redirect to="/writer" />
                    </Route>
                </Switch>
            </div>
        </UserContext.Provider>
        </MuiThemeProvider>
    );
}

export default App;
